import { StyleSheet } from 'aphrodite'

import form from './form'

export default {
  form: StyleSheet.create(form)
}



// WEBPACK FOOTER //
// ./src/components/Community/Billing/Main/style/ColorBlind/index.js